/**
 * Edit Device Type Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

export const DeviceTypeCategoryEnum = z.enum([
  'Weather Sensor',
  'Soil Sensor',
  'Camera',
  'Motion Sensor',
  'Relay Controller',
  'Solenoid Valve Controller',
  'Flow Meter',
  'Electric Current Sensor',
])

export const DeviceTypeStatusEnum = z.enum([
  'research',
  'testing',
  'certified',
])

export type DeviceTypeCategory = z.infer<typeof DeviceTypeCategoryEnum>
export type DeviceTypeStatus = z.infer<typeof DeviceTypeStatusEnum>

export const EditDeviceTypeFormSchema = z.object({
  deviceTypeNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  deviceTypeName: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters'),
  deviceTypeModel: z
    .string()
    .max(50, 'Model cannot exceed 50 characters')
    .optional(),
  deviceTypeManufacturerNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  deviceTypeCategory: DeviceTypeCategoryEnum,
  deviceTypeStatus: DeviceTypeStatusEnum,
})

export type EditDeviceTypeFormData = z.infer<typeof EditDeviceTypeFormSchema>

export function transformToApiRequest(formData: EditDeviceTypeFormData) {
  return {
    deviceTypeNumber: formData.deviceTypeNumber, // Business key for upsert
    deviceTypeName: formData.deviceTypeName,
    deviceTypeManufacturerNumber: formData.deviceTypeManufacturerNumber,
    deviceTypeModel: formData.deviceTypeModel,
    deviceTypeCategory: formData.deviceTypeCategory,
    deviceTypeStatus: formData.deviceTypeStatus,
  }
}
